"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquizImageWidget = void 0;
const react_1 = __importStar(require("react"));
const formatted_text_editor_1 = require("@squiz/formatted-text-editor");
const resource_browser_1 = require("@squiz/resource-browser");
const getResourceValue = (formData) => {
    if (formData) {
        if (formData.matrixAssetId && formData.matrixIdentifier) {
            return {
                resourceId: formData.matrixAssetId,
                sourceId: formData.matrixIdentifier,
            };
        }
        if (formData.damObjectId && formData.damSystemIdentifier) {
            return {
                resourceId: formData.damObjectId,
                sourceId: formData.damSystemIdentifier,
            };
        }
    }
    return null;
};
const SquizImageWidget = ({ disabled, formData, onChange }) => {
    const { matrix } = (0, react_1.useContext)(formatted_text_editor_1.EditorContext);
    const handleChange = (resource) => {
        let resourceSource = undefined;
        if (resource?.source.type === 'dam') {
            resourceSource = {
                damObjectId: resource.id,
                damSystemType: resource.source.configuration.externalType.toLowerCase(),
                damSystemIdentifier: resource.source.id,
            };
        }
        if (resource?.source.type === 'matrix') {
            resourceSource = {
                matrixAssetId: resource.id,
                matrixDomain: matrix.matrixDomain,
                matrixIdentifier: resource.source.id,
            };
        }
        onChange(resourceSource);
    };
    return (react_1.default.createElement(resource_browser_1.ResourceBrowser, { modalTitle: "Insert image", allowedTypes: ['image'], isDisabled: disabled, onChange: handleChange, value: getResourceValue(formData) }));
};
exports.SquizImageWidget = SquizImageWidget;
